import styled from 'styled-components';
import { Title } from '../Form/AutocompleteDropdown/styles';

export const FlagLineContainer = styled.div`
  // This is a hack to make sure the extra line height from the flag emoji is accommodated.
  ${Title} {
    line-height: 1.15;
  }
`;
